export const FormNames = {
  billingAddress: 'billingAddress',
  shippingAddress: 'shippingAddress',
  consentGroup: 'consentGroup',
  contactDetails: 'contactDetails',
};
